import * as React from "react";
import { Header } from "../../components/Header";
import "./FactSheetPage.scss";
import { ReactComponent as Person } from "./img/CES-FactSheet-Icon_Person.svg";
import { ReactComponent as Corn } from "./img/CES-FactSheet-Icon_Corn.svg";
import { ReactComponent as Wheat } from "./img/CES-FactSheet-Icon_Wheat.svg";
import { ReactComponent as Measurement } from "./img/CES-FactSheet-Icon_Measurement.svg";
import { ReactComponent as Satellite } from "./img/CES-FactSheet-Icon_Satellite.svg";
import { ReactComponent as Target } from "./img/CES-FactSheet-Icon_Target.svg";
import { ReactComponent as Labor1 } from "./img/labor_1.svg";
import { ReactComponent as Labor2 } from "./img/labor_2.svg";
import { ReactComponent as Labor3 } from "./img/labor_3.svg";
import { ReactComponent as Runs1 } from "./img/runs_1.svg";
import { ReactComponent as Runs2 } from "./img/runs_3.svg";
import { ReactComponent as Runs3 } from "./img/runs_2.svg";
import { ReactComponent as FoodDemand } from "./img/food_demand.svg";
import { ReactComponent as WorldWideReach } from "./img/worldwide_reach.svg";
import { ReactComponent as FamilyBusiness } from "./img/family_business.svg";
import Footer from "../../components/Footer";
import { AnchorOutlineButton } from "../../components/OutlineButton";

interface IFactSheetPageProps {}

export const FactSheetPage: React.FunctionComponent<IFactSheetPageProps> = (
  props
) => {
  return (
    <div className="FactSheetPage">
      <Header />
      <div className="banner">Quick Facts</div>
      <div className="sub-banner" />

      <div className="parent">
        <div className="div1">
          <div>
            <h3>
              <span>GROWING MORE FOR</span> <span>A GROWING PLANET</span>
            </h3>
            <div className="flex">
              <div>
                <div className="icon">
                  <Person />
                  <Person />
                  <Person />
                  <Person />
                  <Person />
                  <Person />
                  <Person />
                </div>
                <p>
                  The world’s population is expected to grow to nearly{" "}
                  <strong className="nobr">10 billion by 2050,</strong>{" "}
                  increasing global food demand by <strong>50%.</strong>
                </p>
                {/* <div className="footnote">(World Population Prospects 2019: Highlights, United Nations)</div> */}
              </div>
              <div>
                <div className="icon">
                  <Corn />
                  <Wheat />
                  <Corn />
                  <Wheat />
                  <Corn />
                  <Wheat />
                  <Corn />
                </div>
                <p>
                  To reduce hunger and serve a growing population, we need to
                  increase agricultural productivity by{" "}
                  <strong className="nobr">60 to 70%.</strong>
                </p>
                {/* <div className="footnote">(Food and Agriculture Organization of the United Nations)</div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="div2">
          <div>
            <h3>WORLDWIDE REACH</h3>
            <div className="icon-flex">
              <div>
                <WorldWideReach />
              </div>
              <p>
                Over <strong>300 million acres</strong> across{" "}
                <strong>60+ countries</strong> around the world leveraged{" "}
                <span className="nobr">John Deere</span> connected equipment and
                digital technology in 2021. This is three times the size of
                California.
              </p>
            </div>
          </div>
        </div>
        <div className="div3">
          <div>
            <h3>
              HOW BIG IS A <span className="nobr">JOHN DEERE</span> FARM?
            </h3>
            <div className="icon-flex">
              <div>
                <Measurement />
              </div>
              <p>
                <strong><span className="nobr">John Deere</span> Precision Ag Technology</strong> is used on
                farms of all sizes, from 100– 10,000 acres and more (one acre is
                about the same size as a football field). These farms can have
                over <strong>750 million plants</strong>.
              </p>
            </div>
          </div>
        </div>
        <div className="div4 triple">
          <h3>LABOR SHORTAGE IS A BIG CHALLENGE</h3>
          <div className="icon-flex">
            <div>
              <Labor1 />
              <p>
                Urban areas make up only{" "}
                <strong>3% of the entire land area</strong> of the country but
                are home to more than{" "}
                <strong>80 percent of the population</strong>. Conversely,{" "}
                <strong>97% of the country’s land mass</strong> is rural, but
                only <strong>19.3% of the population</strong> lives there.
              </p>
            </div>
            <div>
              <Labor2 />
              <p>
                The average farmer is <strong>over the age of 55</strong> and
                putting in 12–18 hours a day of work to grow food for all of us.
              </p>
            </div>
            <div>
              <Labor3 />
              <p>
                <strong>Less than 2%</strong> of the U.S. population is actively
                involved in agricultural production.
              </p>
            </div>
          </div>
        </div>
        <div className="div5">
          <div>
            <h3>Meeting Food Demand</h3>
            <div className="icon-flex">
              <div>
                <FoodDemand />
              </div>
              <ul>
                <li>
                  Nearly <strong>10% of the world’s population</strong> — an
                  estimated <strong>768 million people</strong> — were
                  undernourished in 2020. In 2019, this total was 8.4%.
                </li>
                <li>
                  One U.S. farm alone feeds <strong>166 people</strong> around
                  the world every year.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="div6">
          <div>
            <h3>MAPPING THE FIELD</h3>
            <div className="icon-flex">
              <div>
                <Satellite />
              </div>
              <p>
                Most <span className="nobr">John Deere</span> machines are built with a GPS receiver, which
                enables the operator to run the machine hands-free using sensors
                and computer vision to drive equipment at an accuracy{" "}
                <strong>within less than 1 inch</strong>. This is extremely
                precise in comparison with a typical GPS-enabled smartphone that
                is accurate to within a 4.9-meter (16 feet) radius under the
                open sky.
              </p>
            </div>
          </div>
        </div>
        <div className="div7 triple">
          <h3>NOTHING RUNS LIKE A DEERE™. AUTONOMOUSLY.</h3>
          <div className="icon-flex">
            <div>
              <Runs1 />
              <p>
                The <span className="nobr">John Deere</span> autonomous 8R Tractor collected over{" "}
                <strong>50 million images</strong> during in-field testing over
                the past 3 years. Each model is trained with hundreds of
                thousands of images, and its neural network classifies each
                pixel in about <strong>100 milliseconds</strong>.
              </p>
            </div>
            <div>
              <Runs3 />
              <p>
                The autonomous 8R Tractor can prepare over{" "}
                <strong>325 acres of soil</strong> in 24 hours — that’s bigger
                than the land area of the National Mall in Washington, D.C.
              </p>
            </div>
            <div>
              <Runs2 />
              <p>
                Depending on the crop a farmer is growing, it can take{" "}
                <strong>7–15 passes across a single field</strong> to grow a
                healthy, abundant crop. With the autonomous 8R Tractor in
                tillage, farmers are instantly{" "}
                <strong>two times more productive</strong> because they can do
                two jobs at once — focusing their attention on more critical,
                time-sensitive work.
              </p>
            </div>
          </div>
        </div>
        <div className="div8">
          <div>
            <h3>It’s a Family Business</h3>
            <div className="icon-flex">
              <div>
                <FamilyBusiness />
              </div>
              <ul>
                <li>
                  Family farms account for almost <strong>96%</strong> of the
                  over <strong>2.2 million farms</strong> in the U.S.
                </li>
                <li>
                  Small and family farms produce more than{" "}
                  <strong>78% of the food and fiber products</strong> sold in
                  the U.S.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="div9">
          <div>
            <h3>PINPOINT SUSTAINABILITY</h3>
            <div className="icon-flex">
              <div>
                <Target />
              </div>
              <p>
                Over the course of 1 growing season, a <span className="nobr">John Deere</span> farmer
                utilizing foundational Precision Ag Technology avoids over{" "}
                <strong>
                  400,000 kg of CO<sub>2</sub> emissions
                </strong>{" "}
                – the equivalent of over{" "}
                <strong>992,000 passenger car miles</strong> driven per year.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="download-link">
        <AnchorOutlineButton
          className="yellow"
          text="Download Fact Sheet"
          to={
            "https://jd-ces-2022.s3.amazonaws.com/media-resources/CES-FactSheet.pdf"
          }
        />
      </div>
      <Footer />
    </div>
  );
};
